import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';  
import { environment } from '../../../environments/environment';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalGeneralComponent } from '../../dashboard/user/modals/modal-general/modal-general.component';
import { MatDialog } from '@angular/material/dialog';
import { getCookie } from '../../utils/getCookies';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-company-recover-password',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule, CommonModule, TranslateModule],
  templateUrl: './company-recover-password.component.html',
  styleUrl: './company-recover-password.component.scss'
})
export class CompanyRecoverPasswordComponent {
  recoverPasswordForm: FormGroup;
  isLoading = false;
  errorMessage: string | null = null;
  coming_from_extension: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog,
    private translate: TranslateService,
    private route: ActivatedRoute) 
  {
    this.recoverPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      user_type: ['company', [Validators.required]]
    });   

    // then we need to see if we have an actual access token (we need to check if is valid or not)
    const accessToken = getCookie('access_token');
    if (accessToken && accessToken !== '') {
        this.http.get(`${environment.url}/api/v1/company/check_access_token`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        }).subscribe({
            next: (response: any) => {
                if (response) {
                  this.router.navigate(['/company/settings']);
                    
                }
            },
            error: (error: any) => {
                console.error('Error:', error);
            }
        })
    }

    // we check if we have a param token_mail
    this.route.queryParams.subscribe((params: any) => {
      if (params['coming_from_extension'] && (params['coming_from_extension'] === '1' || params['coming_from_extension'] === 1)) {
        this.coming_from_extension = true;
      }
      else{
        this.coming_from_extension = false;
      }
    });
  }

  onSubmit() {
    if (this.recoverPasswordForm.valid) {
      this.isLoading = true;
      this.http.post(`${environment.url}/api/v1/password/forgot`, this.recoverPasswordForm.value).subscribe({
        next: (response: any) => {
            console.log(response);
            this.isLoading = false;
            ModalGeneralComponent.open(this.dialog, {
              title: this.translate.instant('companyRecoverPassword.modals.success.title'),
              message: this.translate.instant('companyRecoverPassword.modals.success.message', { email: this.recoverPasswordForm.value.email }),
              buttonText: this.translate.instant('companyRecoverPassword.modals.success.buttonText'),
              type: 'success',
              specific: true,
              link: '/company/login',
              coming_from_extension: this.coming_from_extension
            }); 
        },
        error: (error: any) => {
            console.error('Error:', error);
            this.isLoading = false;
            if (error.status === 401) {
                this.errorMessage = error.error.message;
            } else if (error.status === 500) {
                this.errorMessage = error.error.message;
            } else {
              ModalGeneralComponent.open(this.dialog, {
                title: this.translate.instant('companyRecoverPassword.modals.error.title'),
                message: error.error.message,
                buttonText: this.translate.instant('companyRecoverPassword.modals.error.buttonText'),
                type: 'error',
                specific: true,
                link: '/company/recover-password',
                coming_from_extension: this.coming_from_extension
              }); 
                this.errorMessage = error.error.message;
            }
        }
      });    
    }
  }
}
